<template>
  <div class="select-product">
    <recommend-product
      @selectProduct="selectProduct"
      @showDetailPopup="showProductDetailPopup"
      @clickAddToCart="addToCart"
    ></recommend-product>
    <div class="header-wrap-group">
      <!-- pc端 -->
      <div class="header-wrap pc">
        <div class="title">{{ selectProductTitle }}</div>
        <!-- 分类、价格排序 -->
        <div class="btn-group" v-if="showToolBar">
          <button
            v-show="showTypeBtn"
            class="order-btn flex-between j-select-order"
            :class="{ active: isShowTypeSelecter }"
            @click.stop="updateOrderType('type')"
          >
            <span>{{ currencyTypeName || selectProductTitle }}</span>
            <Icon class="order-icon" name="down"></Icon>
          </button>
          <button
            class="order-btn flex-between j-select-order"
            :class="{ active: curOrderType !== 'priceUp' }"
            @click.stop="showPriceSelecterHandle"
          >
            {{
              curOrderType === 'priceDown'
                ? letter.storePriceDown
                : letter.storePriceUp
            }}
            <Icon class="order-icon" name="down"></Icon>
          </button>
        </div>
        <!-- 搜索 -->
        <div class="search-input-wrap" v-if="showToolBar">
          <input
            :placeholder="searchPlaceholder[curSearchType]"
            class="search-input"
            v-model.trim="searchVal"
            ref="searchInput"
          />
          <Icon class="search-input-ico" name="search"></Icon>
        </div>
      </div>
      <!-- 移动端 -->
      <div class="header-wrap mobile" v-if="showToolBar">
        <!-- 分类、价格排序 -->
        <button
          v-show="showTypeBtn"
          class="order-btn flex-between j-select-order"
          :class="{ active: isShowTypeSelecter }"
          @click.stop="updateOrderType('type')"
        >
          <span>{{ currencyTypeName || selectProductTitle }}</span>
          <Icon class="order-icon" name="down"></Icon>
        </button>
        <button
          class="order-btn flex-between j-select-order"
          :class="{ active: curOrderType !== 'priceUp' }"
          @click.stop="showPriceSelecterHandle"
        >
          {{
            curOrderType === 'priceDown'
              ? letter.storePriceDown
              : letter.storePriceUp
          }}
          <Icon class="order-icon" name="down"></Icon>
        </button>
      </div>
      <!-- 分类选择弹窗 -->
      <div
        class="order-type-popup shadow"
        v-show="isShowTypeSelecter"
        v-clickoutside="hideTypeSelecterHandle"
      >
        <div class="order-type-content">
          <div
            class="product-type-select-item j-select-product-type"
            :pointValue="item.value"
            pointClass="`j-select-product-type`"
            :key="item.value"
            v-for="item in productType"
            @click="updateProductType(item.value)"
            :id="`j-product-type-${item.value}`"
          >
            <div
              class="product-type-select-item-bg"
              :class="{ active: curProductType == item.value }"
            ></div>
            <img
              v-if="productTypeImg(item)"
              :src="productTypeImg(item)"
              class="type-img"
              alt=""
            />
            <p class="type-name">{{ item.name }}</p>
          </div>
        </div>
      </div>
      <!-- 价格选择弹窗 -->
      <div
        class="price-type-popup shadow"
        :class="{ left: !showTypeBtn }"
        v-show="isShowPriceSelecter"
        v-clickoutside="hidePriceSelecterHandle"
      >
        <div
          class="price-item"
          :class="{ active: curOrderType == 'priceDown' }"
          @click="updateOrderType('priceDown')"
        >
          {{ letter.storePriceDown }}
        </div>
        <div
          class="price-item"
          :class="{ active: curOrderType == 'priceUp' }"
          @click="updateOrderType('priceUp')"
        >
          {{ letter.storePriceUp }}
        </div>
      </div>
    </div>
    <template v-if="notCartAndNoSelectProduct || isCartAndNoLoadPaytype">
      <div class="product-wrap" v-if="allProductList.length > 0">
        <product-item
          v-for="(item, index) in productList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID + index"
          :item="item"
          @selectProduct="selectProduct"
          @showDetailPopup="showProductDetailPopup"
          @clickAddToCart="beforeAddToCartCheck"
          :selectItem="selectItem"
          :isPreProduct="false"
        ></product-item>
      </div>
      <div class="product-wrap" v-else>
        <product-item
          v-for="(item, index) in preProductList"
          :key="item.PRODUCT_ID + index"
          :item="item"
          selectItem=""
          :isPreProduct="true"
          @selectProduct="handlerPopup"
          @clickAddToCart="handlerPopup"
          @showDetailPopup="showProductDetailPopup"
        ></product-item>
      </div>
    </template>
    <transition name="fade">
      <cart-submit-footer
        v-if="!hasLoadPaytype && isLandscape"
      ></cart-submit-footer>
    </transition>
    <transition name="fade">
      <AreaConfirmPopup
        v-if="showAreaConfirmPopup"
        :havePayWay="havePayWay"
        @hidePopup="handleAreaConfirmPopup(false)"
        @confirmSwitchArea="confirmSwitchArea"
        @handleZipCodeConfirmPopup="handleZipCodeConfirmPopup"
      ></AreaConfirmPopup>
    </transition>
    <transition name="fade">
      <ZipCodeConfirmPopup
        v-if="showZipCodeConfirmPopup"
        mode=""
        @handleZipCodeConfirmPopup="handleZipCodeConfirmPopup"
        @confirmSwitchArea="confirmSwitchArea"
      ></ZipCodeConfirmPopup>
    </transition>
    <CommonUidTokenLoginPopup
      v-bind:visible.sync="visibleAreaCommonTokenLoginPopup"
    ></CommonUidTokenLoginPopup>
    <PopupWindow
      @onCancel="areaErrorPopup = false"
      @onConfirm="areaErrorPopup = false"
      type="tips"
      v-if="areaErrorPopup"
      :languages="letter"
      :content="areaErrorTips"
    ></PopupWindow>
    <about-currency-popup
      v-bind:visible.sync="visibleCurrenyGuidePopup"
    ></about-currency-popup>
    <product-detail-popup
      style="z-index: 1001"
      v-if="productDetailPopupVisible"
      @selectProduct="selectProduct"
      @clickAddToCart="beforeAddToCartCheck"
      @closeSelecter="hideProductDetailPopup"
      :showBtn="showDeatilBtn"
      :showChildSelector="productDetailPopupVisible"
      :product="productDetailPopupProduct"
    ></product-detail-popup>
    <switch-version></switch-version>
  </div>
</template>

<script type="text/javascript">
import { getProductDefaultImg } from '@utiles/officialStore/productImg';
import globalConfig from '@utiles/officialStore/globalConfig';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import {
  SET_SHOW_CHANNEL_STATUS,
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  LOAD_PAYTYPE_LIST_DATA,
  UPDATE_HAS_SELECT_PRODUCT,
  GET_PRE_PRODUCT_LIST,
  SHOW_PRODUCT_DETAIL_POPUP,
  CLOSE_PRODUCT_DETAIL_POPUP,
  GET_THIRD_PARTY_PRODUCT_ID
} from '@store/officialTopup';
import {
  storeProductParam,
  storeCpProductId,
  getCurLocation,
  setDefaultPrice
} from '@store/officialTopup/storager';
import {
  LOAD_CART_PAYTYPE_LIST_DATA,
  UPDATE_SHOW_CARTLIST_STATUS
} from '@store/officialTopup/cart';
import ProductItem from '@components/officialTopup/product/ProductItem.vue';
import SearchTypeSelecter from '@components/officialTopup/product/SearchTypeSelecter';
import ProductDetailPopup from '@components/officialTopup/product/ProductDetailPopup.vue';
import AboutCurrencyPopup from '@components/officialTopup/AboutCurrencyPopup.vue';
import CartSubmitFooter from '@components/officialTopup/cart/CartSubmitFooter.vue';
import RecommendProduct from '@components/officialTopup/product/RecommendProduct.vue';
import AreaConfirmPopup from '@components/officialTopup/paytype/AreaConfirmPopup';
import ZipCodeConfirmPopup from '@components/officialTopup/paytype/ZipCodeConfirmPopup';
import CommonUidTokenLoginPopup from '@components/officialTopup/login/CommonUidTokenLoginPopup';
import SwitchVersion from '@components/officialTopup/SwitchVersion.vue';

import coupon from '@mixins/officialTopup/coupon';
import login from '@mixins/officialTopup/login';
import pay from '@mixins/officialTopup/pay';
import style from '@mixins/officialTopup/style';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import switchArea from '@mixins/officialTopup/switchArea';

import clickOutside from '../../../diractives/officialStore/clickOutside';
import { mapState, mapGetters } from 'vuex';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import {
  popupType,
  showPopup,
  clickButton,
  locationType
} from '@plugins/biPoint/_configWebstoreV3';

const isFromIframe = globalConfig.getHrefParam('fromIframe') || '';
const PRODUCT_OFF_POPUP_HIDE = 'PRODUCT_OFF_POPUP_HIDE';
const PACKAGE_TAG_LIST = [
  'hot',
  'discount',
  'double',
  'treble',
  'sale',
  'top_seller',
  'off_10',
  'off_20',
  'off_30',
  'off_40',
  'off_50',
  'off_60',
  'off_70',
  'off_80',
  'off_90',
  'event',
  'daily',
  'weekly',
  'monthly'
];
export default {
  name: 'webSelectProduct',
  mixins: [coupon, login, pay, style, cartAddAndDetail, switchArea],
  data() {
    let productIdForCoinResolve = () => {};
    let productIdForCoinPromise = new Promise(resolve => {
      productIdForCoinResolve = resolve;
    });

    return {
      uidGame: globalConfig.isUidGame(),
      mainHost: globalConfig.getMainHost(),
      curOrderType: 'normal',
      curProductType: '',
      searchVal: '',
      scroll: null,
      isShowTypeSelecter: false,
      isShowPriceSelecter: false,
      currencyType: '',
      selectItem: {},
      hasAutoSelect: false,
      curSearchType: 'name',
      PRODUCT_OFF_POPUP_HIDE,
      preProductList: [],
      visibleCurrenyGuidePopup: false,
      isExpandAllType: false,
      showSearchTypeSelecter: false,
      isGoSearch: false,
      debounce: null,
      showDeatilBtn: true,
      productIdForCoin: '',
      productIdForCoinPromise,
      productIdForCoinResolve
    };
  },
  async created() {
    this.transformProductId();
    this.$store.dispatch(GET_PRE_PRODUCT_LIST).then(data => {
      this.preProductList = data;
    });
  },
  watch: {
    allProductList: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        await this.productIdForCoinPromise;
        let productId =
          this.productIdForCoin || globalConfig.getHrefParam('productId') || '';
        let cpProductId = globalConfig.getHrefParam('cpProductId') || '';
        let productList = newVal;

        if (this.matchCpProductid) {
          // 自动选中链接带的商品匹配product_id和cp_product_id
          if (productId && cpProductId && !this.hasAutoSelect) {
            const productItem = productList.find(
              item =>
                item.CP_PRODUCT_ID == cpProductId &&
                item.PRODUCT_ID == productId
            );
            if (productItem) {
              this.autoSelectProduct(productItem);
              return;
            } else {
              errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
                productId,
                cpProductId
              });
            }
          }
        } else {
          if (!this.hasAutoSelect && productList?.length > 0) {
            // 自动选中链接带的商品匹配product_id
            if (productId) {
              const productItem = productList.find(
                item => item.PRODUCT_ID == productId
              );
              if (productItem) {
                this.autoSelectProduct(productItem);
                return;
              } else {
                errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
                  productId,
                  cpProductId
                });
              }
            }
          }
        }
      }
    },
    lang(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      }
    },
    gameActiveCouponId() {
      this.curProductType = 'typeall';
    },
    searchVal(newVal) {
      // 防抖，输入后1s内内容不再变更才触发搜索打点
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        window.webstorev3DataLayer.push({
          eventName: 'search_product',
          eventType: 'name',
          eventReason: newVal
        });
      }, 1000);
    }
  },
  computed: {
    ...mapState({
      hasSelectProduct: state => state.hasSelectProduct,
      lang: state => state.lang,
      allProductList: state => state.productList,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isLogin: state => state.login.isLogin,
      uid: state => state.login.uid,
      gameId: state => state.gameId,
      serverId: state => state.pcServerId,
      roleId: state => state.roleId,
      roleName: state => state.roleName,
      cartList: state => state.cart.cartList,
      selectState: state => state.selectState,
      productDetailPopupVisible: state => state.productDetailPopupVisible,
      productDetailPopupProduct: state => state.productDetailPopupProduct,
      openShoppingCart: state => state.page.openShoppingCart,
      matchCpProductid: state => state.page.matchCpProductid,
      picList: state => state.page.picList,
      isCustomProductType: state => state.page.isCustomProductType,
      customProductTypeLang: state => state.page.customProductTypeLang
    }),
    ...mapGetters(['cartProductType', 'gameInfoConfig', 'isCart']),
    noSelectProduct() {
      return !this.hasSelectProduct;
    },
    notCartAndNoSelectProduct() {
      return !this.isCart && !this.hasSelectProduct;
    },
    isCartAndNoLoadPaytype() {
      return this.isCart && !this.hasLoadPaytype;
    },
    productList() {
      let realProductList = [].concat(
        this.searchVal.length
          ? this.searchProductList
          : this.$store.state.productList
      );
      let _productList = this.filterHideProduct(realProductList);
      _productList = this.filterUseGameCoupon(_productList);
      return this.filterOrder(_productList);
    },
    showToolBar() {
      return this.allProductList.length > 0;
    },
    showTypeBtn() {
      // 如果分类只有一种，隐藏分类按钮（全部分类typeall是默认加入的，因此length > 2）
      return this.productType?.length > 2;
    },
    searchProductList() {
      return this.curSearchType === 'name'
        ? this.$store.getters.getProductListByName(this.searchVal)
        : this.$store.getters.getProductListByPrice(this.searchVal);
    },
    selectProductTitle() {
      return this.letter.selectProductTitle;
    },
    productTypeImg() {
      return item => {
        return this.picList?.[item?.value] || '';
      };
    },
    currencyTypeName() {
      return this.productType?.find(item => item.value === this.curProductType)
        ?.name;
    },
    productTypeLang() {
      return {
        ...this.customProductTypeLang[this.lang],
        typeall: this.letter.typeall,
        typeother: this.letter.typeother
      };
    },
    productType() {
      const TYPES_NAME = {
        coin: this.letter.coinTypeName,
        package: this.letter.packageTypeName,
        subscription: this.letter.subscriptionTypeName,
        currency: this.letter.currencyTypeName,
        typeall: this.letter.typeall
      };
      let res = [];
      if (this.$store.state.productTypes.length < 1) {
        this.curProductType = '';
        return res;
      }
      this.$store.state.productTypes.map(item => {
        if (item) {
          res.push({
            name: this.isCustomProductType
              ? this.productTypeLang[item]
              : this.letter[item] || TYPES_NAME[item],
            value: item
          });
        }
      });
      this.curProductType = res[0].value;
      return res;
    },
    searchType() {
      return [
        { name: this.letter.product, value: 'name' },
        { name: this.letter.price, value: 'price' }
      ];
    },
    searchPlaceholder() {
      return {
        name: this.letter.storeInputNameSearch,
        price: this.letter.storeInputPriceSearch
      };
    },
    curSearchTypeText() {
      return this.searchType.find(item => item.value === this.curSearchType)
        ?.name;
    }
  },
  methods: {
    showTypeSelecterHandle() {
      this.isShowTypeSelecter = !this.isShowTypeSelecter;
    },
    hideTypeSelecterHandle() {
      this.isShowTypeSelecter = false;
    },
    showPriceSelecterHandle() {
      this.isShowPriceSelecter = !this.isShowPriceSelecter;
    },
    hidePriceSelecterHandle() {
      this.isShowPriceSelecter = false;
    },
    handlerPopup() {
      clickButton({
        btnName: 'pre_product_click',
        locationKey: locationType.homePage
      });
      if (!this.isLogin) {
        this.showLoginPopup();
        return;
      }
      this.showSelectRolePopup();
    },
    showAboutPopup() {
      this.visibleCurrenyGuidePopup = true;
      clickButton({
        btnName: 'about_currency_click',
        locationKey: locationType.homePage
      });
      showPopup(popupType.aboutCurrencyPopup);
    },
    lookCart() {
      this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, true);
    },
    autoSelectProduct(item) {
      this.hasAutoSelect = true;
      this.selectProduct(item);
    },
    selectProduct(item) {
      if (this.hasLoadPaytype) {
        this.changeProduct();
      }
      let productId = item.PRODUCT_ID,
        cpProductId = item.CP_PRODUCT_ID,
        remark = item.REMARK;

      this.updateSelectProduct(item);
      const serverId = this.$store.state.serverId;
      const roleId = this.$store.state.roleId;
      if (!serverId || !roleId) {
        alert(this.letter.seletGameInfoFirst);
        return;
      }
      // 搜索打点
      if (this.searchVal.length) {
        commonEmitUpload(
          `search-product-by-${this.curSearchType}`,
          {
            event: `search-product-by-${this.curSearchType}`,
            newPage: true,
            pageName: 'select-product-page',
            type: 'click'
          },
          this.searchVal
        );
      }
      commonEmitUpload(
        `j-select-product`,
        {
          event: `click-update-product`,
          pageName: 'select-product-page',
          type: 'click'
        },
        productId + ';' + cpProductId || ''
      );
      window.webstorev3DataLayer.push({
        eventName: 'select_product',
        eventType: 'buy_now',
        eventReason: this.hasAutoSelect ? 'auto_select' : 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: cpProductId,
          product_id: productId,
          product_num: 1,
          product_currency: this.currency,
          product_money: item.GAME_AMOUNT || ''
        }
      });
      // 保存跳到储值页前的链接，为了返回时能获取跳过去前的信息
      this.saveLink({
        serverId,
        roleId,
        productId,
        cpProductId,
        remark,
        productType: item.PRODUCT_TYPE
      });
      storeProductParam({
        gameId: this.$store.state.gameId,
        serverId: this.$store.state.pcServerId,
        roleId: roleId,
        roleName: this.$store.state.roleName,
        packageName: globalConfig.getHrefParam('packageName'),
        userId: this.uid,
        productId: productId,
        cpProductId: cpProductId,
        devicePlate: globalConfig.getHrefParam('devicePlate'),
        remark: remark,
        location: getCurLocation() || '',
        appLanguage: this.$store.state.lang,
        language: this.$store.state.lang,
        productType: item.PRODUCT_TYPE
      });
      storeCpProductId(cpProductId);
      globalConfig.storeEntryParams();
      setDefaultPrice('');
      this.$store.commit(UPDATE_LOADING, true);
      this.$store.dispatch(LOAD_PAYTYPE_LIST_DATA);
    },
    saveLink(params) {
      const saveLinks =
        '?gameId=' +
        this.$store.state.gameId +
        '&serverId=' +
        params.serverId +
        '&roleId=' +
        params.roleId +
        '&roleName=' +
        encodeURIComponent(this.$store.state.roleName) +
        '&productId=' +
        params.productId +
        '&cpProductId=' +
        params.cpProductId +
        '&remark=' +
        params.remark +
        '&loginAccount=' +
        this.$store.state.login.loginAccount +
        '&userId=' +
        this.$store.state.login.uid +
        '&web=1' +
        '&language=' +
        this.$store.state.lang +
        '&appLanguage=' +
        this.$store.state.lang +
        '&fromIframe=' +
        isFromIframe +
        '&cid=' +
        globalConfig.getHrefParam('cid') +
        '&scid=' +
        globalConfig.getHrefParam('scid') +
        '&packageName=' +
        globalConfig.getHrefParam('packageName') +
        '&hideService=' +
        globalConfig.getHrefParam('hideService') +
        '&productType=' +
        params.productType +
        '#/web';
      sessionStorage.setItem('forwardLinksParam', saveLinks);
    },
    updateOrderType(value) {
      switch (value) {
        case 'type':
          this.showTypeSelecterHandle();
          return;
        case 'priceDown':
          this.curOrderType = 'priceDown';
          clickButton({
            btnName: 'switch_sorting',
            locationKey: 'price_down'
          });
          this.hidePriceSelecterHandle();
          break;
        case 'priceUp':
          this.curOrderType = 'priceUp';
          clickButton({
            btnName: 'switch_sorting',
            locationKey: 'price_up'
          });
          this.hidePriceSelecterHandle();
          break;
        default:
          break;
      }
    },
    getProductDefaultIcon(type) {
      return getProductDefaultImg(type);
    },
    updateSelectProduct(item) {
      this.selectItem = item;
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, true);
    },
    changeProduct() {
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
    },
    filterHideProduct(realProductList) {
      let productList = [];
      for (let key in realProductList) {
        //需求方：区天衡 -  如果CP_PRODUCT_ID为10_1_-1 11_1_-1 12_1_-1 13_1_-1 426005_1_-1，则不显示
        let hideProductArr = [
          '10_1_-1',
          '11_1_-1',
          '12_1_-1',
          '13_1_-1',
          '426005_1_-1'
        ];
        if (
          realProductList[key].CP_PRODUCT_ID &&
          hideProductArr.includes(String(realProductList[key].CP_PRODUCT_ID))
        ) {
          continue;
        }

        if (
          this.curProductType &&
          this.curProductType !== 'typeall' &&
          this.curProductType != realProductList[key].itemType
        ) {
          continue;
        }

        productList.push(realProductList[key]);
      }

      return productList;
    },
    filterUseGameCoupon(productList) {
      if (
        this.gameActiveCouponId &&
        this.activeGameCouponProductList.length > 0
      ) {
        return productList.filter(item => {
          return this.checkInGameActiveCoupon(
            item.PRODUCT_ID,
            item.CP_PRODUCT_ID
          );
        });
      }
      return productList;
    },
    updateProductType(value) {
      clickButton({
        btnName: 'switch_producttype',
        locationKey: value
      });
      this.hideTypeSelecterHandle();
      this.curProductType = value;
    },
    selectType(type) {
      this.curSearchType = type;
      this.showSearchTypeSelecter = false;
    },
    filterOrder(productList) {
      let res = [];
      let isPackage = this.curProductType == 'package';

      switch (this.curOrderType) {
        // 默认排序
        case 'normal': {
          let tagArr = [];
          let notagArr = [];
          // 先区分是否有tag
          productList.forEach(item => {
            // 只处理礼包的tag，非礼包的不处理
            if (isPackage) {
              if (item.PRODUCT_TAG) {
                // 插入的时候排一下序（tag权重）
                let orderIndex = tagArr.length - 1;
                let isAdd = false;
                while (~orderIndex) {
                  const preTagOrder = PACKAGE_TAG_LIST.indexOf(
                    tagArr[orderIndex].PRODUCT_TAG
                  );
                  const curTagOrder = PACKAGE_TAG_LIST.indexOf(
                    item.PRODUCT_TAG
                  );
                  if (preTagOrder >= curTagOrder) {
                    tagArr.splice(+orderIndex + 1, 0, item);
                    isAdd = true;
                    break;
                  } else {
                    orderIndex--;
                  }
                }
                if (!isAdd) {
                  tagArr.unshift(item);
                }
              } else {
                notagArr.push(item);
              }
            } else {
              notagArr.push(item);
            }
          });
          // 如果都没有tag，就可以结束了
          if (!tagArr.length) {
            res = notagArr;
            break;
          }
          res = tagArr.concat(notagArr);
          break;
        }
        // 价格升序
        case 'priceUp': {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT > +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        // 价格降序
        case 'priceDown': {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT < +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        default:
          break;
      }
      return res;
    },
    visibleShowSearchTypeSelecter(isShow) {
      this.showSearchTypeSelecter = isShow;
    },
    showProductDetailPopup(item) {
      this.showDeatilBtn = item.showBtn;
      this.$store.commit(SHOW_PRODUCT_DETAIL_POPUP, item);
    },
    hideProductDetailPopup() {
      this.$store.commit(CLOSE_PRODUCT_DETAIL_POPUP);
    },
    clearSearch() {
      this.searchVal = '';
      this.isGoSearch = false;
    },
    handleGoSeach() {
      this.isGoSearch = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    async transformProductId() {
      // 内购礼包商品ID转代币商品ID：当商品不存在的时候自动转为价格相似的商品
      const game_id = globalConfig.getHrefParam('gameId');
      const product_id = globalConfig.getHrefParam('productId');
      if (this?.gameInfoConfig?.autoChangeProduct && game_id && product_id) {
        try {
          const res = await this.$store.dispatch(GET_THIRD_PARTY_PRODUCT_ID, {
            game_id,
            product_id,
            f_pay_type: 'google_play'
          });
          this.productIdForCoin = res?.data?.TARGET_PRODUCT_ID || '';
          this.productIdForCoinResolve();
        } catch (error) {
          console.error(error);
          this.productIdForCoinResolve();
        }
      } else {
        this.productIdForCoinResolve();
      }
    },
    beforeAddToCartCheck(item) {
      if (!this.$store.state.roleId) {
        this.handlerPopup();
        return;
      }
      if (!this.havePayWay) {
        this.handleAreaConfirmPopup(true);
        return;
      }
      this.addToCart(item);
    }
  },
  components: {
    ProductItem,
    AboutCurrencyPopup,
    SearchTypeSelecter,
    ProductDetailPopup,
    CartSubmitFooter,
    RecommendProduct,
    AreaConfirmPopup,
    ZipCodeConfirmPopup,
    CommonUidTokenLoginPopup,
    SwitchVersion
  },
  directives: {
    clickoutside: clickOutside
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
@import '@assets/scss/officialTopup/_dimen.scss';
.select-product {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  .header-wrap-group {
    position: sticky;
    top: 120px;
    background-color: $moduleBackgroundColor;
    border-radius: 20px 20px 0 0;
    z-index: 6;
    margin: 0 -40px 10px;
    padding: 0 40px 10px;
  }
  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 32px;
    }

    .search-input-wrap {
      margin-left: 40px;
      height: 60px;
      border-radius: 20px;
      border: solid 1px #e8e8e8;
      padding: 0 20px;
      position: relative;
      display: flex;
      align-items: center;
      flex: 1;

      .search-input {
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        padding: 0 50px 0 0;
        outline: none;
        background-color: transparent;
        background-size: cover;
        line-height: 45px;
        font-size: 22px;
        color: #333333;
        &::-webkit-search-cancel-button {
          display: none;
        }
        &::-webkit-input-placeholder {
          font-size: 18px;
        }
      }
      .search-input-ico {
        position: absolute;
        right: 20px;
        width: 25px;
        height: 25px;
      }
    }
    .btn-group {
      display: none;
    }
    .order-btn {
      text-align: start;
      width: 46%;
      height: 50px;
      border-radius: 20px;
      border: solid 1px #e8e8e8;
      cursor: pointer;
      padding: 0 20px;
      font-size: 22px;
      &:hover {
        font-weight: bold;
      }
    }
    .order-icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      color: #333333;

      &.active {
        transform: rotate(180deg);
      }
    }
  }

  .product-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
    .tip {
      width: 100%;
      text-align: center;
      font-size: 24px;
      color: $themeColor;
    }
  }
}

.order-type-popup {
  z-index: 6;
  width: 100%;
  max-height: 670px;
  overflow-y: scroll;
  position: absolute;
  top: unset;
  left: 0;
  border-radius: 20px;
  background-color: #ffffff;
  .order-type-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .product-type-select-item {
      position: relative;
      height: 224px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      cursor: auto;
      text-align: center;
      font-size: 22px;
      color: #333333;
      background: #ffffff;
      border: 1px solid #e8e8e8;
      box-sizing: border-box;
      z-index: 1;

      &-bg {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &.active {
          background-color: $themeColor;
          opacity: 0.05;
        }
      }

      &:hover {
        cursor: pointer;
        box-shadow: unset;
      }
      .type-img {
        width: 64px;
        height: auto;
        margin-bottom: 20px;
      }
    }
  }
}

.price-type-popup {
  z-index: 6;
  width: 300px;
  position: absolute;
  top: unset;
  left: 50%;
  border-radius: 20px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px;

  &.left {
    left: 10%;
  }

  .price-item {
    padding: 20px 15px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 22px;
    color: #333333;
    box-sizing: border-box;
    z-index: 1;
    &:hover {
      font-weight: bold;
    }
    &.active {
      font-weight: bold;
    }
  }
}

.unlogin-tip {
  text-align: center;
  font-size: 24px;
  color: #c1a15e;
}

.type-section {
  .product-type-select-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    &.expand {
      align-items: flex-start;
      .product-type-select {
        height: auto;
        .content {
          flex-wrap: wrap;
        }
        &-item {
          margin-bottom: 20px;
          margin-left: 0;
          margin-right: 20px;
        }
      }
    }
  }
  .product-type-select {
    overflow: -moz-scrollbars-none;
    overflow-x: hidden;
    overflow-y: auto;
    width: 616px;
    height: 50px;
    white-space: nowrap;
    touch-action: none;
    touch-action: pan-y;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .content {
      display: flex;
      justify-content: flex-start;
    }
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0 20px;
      height: 50px;
      flex-shrink: 0;
      margin-left: 20px;
      cursor: auto;
      text-align: center;
      font-size: 22px;
      color: #333333;
      touch-action: none;
      touch-action: pan-y;
      background: #fff;
      border-radius: 30px;
      @include g-border(2px);
      box-sizing: border-box;
      &.active {
        touch-action: none;
        color: $themeColor;
        box-shadow: unset;
      }
      &:hover {
        cursor: pointer;
        box-shadow: unset;
      }
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: 0;
      }
      .type-img {
        width: 32px;
        height: auto;
        margin-right: 14px;
      }
    }
    &-expand-switch {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      padding: 0 20px;
      border-radius: 30px;
      border: 2px solid $border;
      box-sizing: border-box;
      height: 50px;
      cursor: pointer;
      .icon {
        display: inline-block;
        background: url($commonImg + 'channel-more.png') no-repeat;
        width: 20px;
        height: 19px;
        &.close {
          transform: rotate(180deg);
        }
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .select-product {
    width: 100%;
    padding: 0;
    .header-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: unset;

      .search-input-wrap {
        margin-left: 0;
        height: 50px;
      }

      &.mobile {
        display: none;
      }

      &.pc {
        .order-btn {
          display: flex;
        }

        .btn-group {
          display: flex;
          justify-content: flex-end;
          width: 588px;
          .order-btn {
            width: 207px;
            margin-right: 10px;
          }
        }
      }
    }

    .product-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .tip {
        font-size: 18px;
      }
    }
  }
  .order-type-popup {
    top: 90px;
    .order-type-content {
      grid-template-columns: repeat(5, 1fr);
      .product-type-select-item {
        font-size: 18px;
      }
    }
  }
  .price-type-popup {
    &.left {
      left: 50%;
    }
  }

  .type-section {
    .product-type-select {
      width: 770px;
      &-item {
        font-size: 18px;
      }
    }
  }
  .sort-and-search {
    .order-type-wrap {
      .order-btn {
        font-size: 18px;
      }
    }
    .search-content {
      width: 500px;
    }
    .search-wrap {
      font-size: 16px;
      .search-input {
        font-size: 16px;
      }
    }
  }
}
</style>
